export default "__VITE_ASSET__Dooe_Vpe__"